import { render, staticRenderFns } from "./editRoles.vue?vue&type=template&id=2b00ee98&"
import script from "./editRoles.vue?vue&type=script&lang=ts&"
export * from "./editRoles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports